import { ReactNode, useState } from 'react';

import { AuthFactoryContext } from './AuthFactoryContext';
import { UseAuthContextType } from './auth0/auth.types';
import { getDefaultUseAuthState } from './auth0/helpers';
import {
  LOCAL_STORAGE_OVERRIDE_TOKEN_PERSIST,
  SESSION_STORAGE_OVERRIDE_TOKEN,
} from './override/config';

export const MockAuthFactoryProvider = ({
  useAuthState = {},
  children,
}: {
  useAuthState?: Partial<UseAuthContextType>;
  children: ReactNode;
}) => {
  const [overrideToken, setOverrideToken] = useState<string | undefined>();
  const useAuth = () => getDefaultUseAuthState(useAuthState);

  return (
    <AuthFactoryContext.Provider
      value={{
        overrideToken,
        setOverrideToken,
        useAuth,
      }}
    >
      {children}
    </AuthFactoryContext.Provider>
  );
};

export const isTestEnvironment = () => {
  if (typeof window === 'undefined') return false;

  // need to check both to avoid `/debug` override false positive
  return (
    !!window.localStorage.getItem(LOCAL_STORAGE_OVERRIDE_TOKEN_PERSIST) &&
    !!window.sessionStorage.getItem(SESSION_STORAGE_OVERRIDE_TOKEN)
  );
};
